// APP INSIGHTS
export const INSTRUMENTATION_KEY =
  process.env.NODE_ENV === 'production' ? '#{AppInsightsInstrumentationKey}' : '1234567890';

export const REPLACE_TITLE = 'Yorkshire Water |';
export const IS_ENABLED = false;

// eslint-disable-next-line import/no-anonymous-default-export
export default { INSTRUMENTATION_KEY, IS_ENABLED, REPLACE_TITLE };
